import * as T from '@clientos/types';
import IBreadcrumbService from '../../../services/breadcrumbService/IBreadcrumbService';
import { getServices } from '../../../infra/startup';
import bindAllMethods from '../../../utils/bindAllMethods';

class BreadcrumbInterfaceV1 {
  private _breadcrumbService: IBreadcrumbService;

  constructor() {
    const services = getServices();
    this._breadcrumbService = services.breadcrumbService;
    bindAllMethods(this);
  }

  listen(callback: T.BreadcrumbListenerCallbackType): () => void {
    return this._breadcrumbService.listen(callback);
  }

  useReactListener(React: any): T.BreadcrumbItemType[] {
    return this._breadcrumbService.useReactListener(React);
  }

  getBreadcrumbs(): T.BreadcrumbItemType[] {
    return this._breadcrumbService.getBreadcrumbs();
  }

  add(breadcrumbItem: T.BreadcrumbItemType): void {
    this._breadcrumbService.add(breadcrumbItem);
  }

  isEnabled(): boolean {
    return this._breadcrumbService.isEnabled();
  }

  remove(breadcrumbKey: string): void {
    this._breadcrumbService.remove(breadcrumbKey);
  }

  public getInterface(): T.BreadcrumbInterfaceType {
    return {
      listen: this.listen,
      useReactListener: this.useReactListener,
      getBreadcrumbs: this.getBreadcrumbs,
      add: this.add,
      isEnabled: this.isEnabled,
      remove: this.remove
    };
  }
}

export default BreadcrumbInterfaceV1;
